import { Controller } from "@hotwired/stimulus"

// Calcolatore della pagina /confronto: quando cambiano la dimensione del team
// o il cambio, ricalcola il costo per riga, i totali e le barre del grafico.
// Stessa matematica di SaasComparison (app/models): il primo render è del
// server, qui si aggiorna soltanto.
export default class extends Controller {
  static targets = ["team", "rate", "month", "monthSub", "year", "chartSub"]
  static values = { items: Array }

  connect() {
    const it = new Intl.NumberFormat("it-IT", { maximumFractionDigits: 2 })
    const whole = new Intl.NumberFormat("it-IT", { maximumFractionDigits: 0 })
    // Stesso formato del server: cifre all'italiana, valuta dopo il numero.
    this.eur = { format: (n) => `${it.format(n)} €` }
    this.eurWhole = { format: (n) => `${whole.format(n)} €` }
    this.usd = { format: (n) => `${it.format(n)} $` }
  }

  step(event) {
    const delta = Number(event.params.delta)
    this.teamTarget.value = Math.min(200, Math.max(1, (Number(this.teamTarget.value) || 1) + delta))
    this.update()
  }

  update() {
    const team = Math.min(200, Math.max(1, Number(this.teamTarget.value) || 1))
    const rate = Number(this.rateTarget.value) || 0.86
    let total = 0, usd = 0, eur = 0
    const rows = []

    for (const item of this.itemsValue) {
      const cost = this.teamCost(item, team)
      const inEur = item.currency === "EUR" ? cost : cost * rate
      total += inEur
      if (item.currency === "EUR") eur += cost; else usd += cost
      rows.push({ key: item.key, eur: inEur })

      const row = this.element.querySelector(`[data-comparison-row="${item.key}"]`)
      if (!row) continue
      row.querySelector("[data-team-cost]").textContent = this.money(cost, item.currency)
      const conv = row.querySelector("[data-eur-cost]")
      if (conv) conv.textContent = item.currency === "EUR" ? "" : this.eurWhole.format(inEur)
    }

    this.monthTarget.textContent = this.eurWhole.format(total)
    this.yearTarget.textContent = this.eurWhole.format(total * 12)
    this.monthSubTarget.textContent = `${this.usd.format(Math.round(usd))} + ${this.eurWhole.format(eur)} per ${team} ${team === 1 ? "persona" : "persone"}`
    if (this.hasChartSubTarget) this.chartSubTarget.textContent = `Team di ${team}, ${this.eurWhole.format(total)} al mese in totale`

    const max = Math.max(...rows.map((r) => r.eur))
    const chart = this.element.querySelector("[data-comparison-chart]")
    if (!chart) return
    rows.sort((a, b) => b.eur - a.eur)
    rows.forEach((r, i) => {
      const bar = chart.querySelector(`[data-bar="${r.key}"]`)
      if (!bar) return
      bar.style.order = i
      bar.querySelector("[data-bar-fill]").style.width = `${(r.eur / max * 100).toFixed(1)}%`
      bar.querySelector("[data-bar-value]").textContent = this.eurWhole.format(r.eur)
    })
  }

  teamCost(item, team) {
    const seats = item.seats === "team" ? team : Number(item.seats)
    if (item.kind === "seat") return item.price * seats
    if (item.kind === "flat") return item.price
    if (item.kind === "flat_plus") return item.price + item.perUser * Math.max(0, seats - item.included)
    return 0
  }

  money(n, currency) {
    return (currency === "EUR" ? this.eur : this.usd).format(n)
  }
}
